import React from "react";
import { Image } from "antd";

import { getToken } from "services/token-service/token.service";
import { useProfileMedia } from "../api/conversations";

const MediaComponent = (props) => {
  const { convData } = props;
  const token = getToken();

  const { data: images } = useProfileMedia({ data: convData, token });

  // console.log("data ===> ", images?.data.data);
  return (
    <div className="MediaContainer">
      <Image.PreviewGroup>
        {images?.data.data.map((image) => {
          return (
            <Image
              key={image.name}
              className={image?.has_been_sent ? "SentImage" : ""}
              width={85}
              height={85}
              src={image.thumbnail_url}
            />
          );
        })}
      </Image.PreviewGroup>
    </div>
  );
};

export default MediaComponent;
